import { Skeleton, SkeletonItem } from "@fluentui/react-components";
import React from "react";

export const LoadingState: React.FC = () => (
  <div style={{ padding: "20px" }}>
    <Skeleton>
      <SkeletonItem shape="rectangle" size={16} animation="pulse" style={{ width: "30%" }} />
      <SkeletonItem shape="rectangle" size={16} animation="pulse" style={{ width: "80%", marginTop: "40px" }} />
      <SkeletonItem shape="rectangle" size={16} animation="pulse" style={{ width: "60%", marginTop: "12px" }} />
      <SkeletonItem shape="rectangle" size={16} animation="pulse" style={{ width: "40%", marginTop: "12px" }} />
      <SkeletonItem shape="rectangle" size={16} animation="pulse" style={{ width: "80%", marginTop: "40px" }} />
      <SkeletonItem shape="rectangle" size={16} animation="pulse" style={{ width: "60%", marginTop: "12px" }} />
      <SkeletonItem shape="rectangle" size={16} animation="pulse" style={{ width: "40%", marginTop: "12px" }} />
    </Skeleton>
  </div>
);